
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsColorGrid extends Serenity.EntityGrid<CsColorRow, any> {
        protected getColumnsKey() { return CsColorColumns.columnsKey; }
        protected getDialogType() { return CsColorDialog; }
        protected getIdProperty() { return CsColorRow.idProperty; }
        protected getInsertPermission() { return CsColorRow.insertPermission; }
        protected getLocalTextPrefix() { return CsColorRow.localTextPrefix; }
        protected getService() { return CsColorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}